module.exports = __webpack_public_path__ + "static/semantic-image-rounded-a155260cba7729a6c79f10e5d3380648.png";